import { AnswerOptionsList } from '../AnswerOptionsList';

import type { AnswerOptionConfig } from '../AnswerOptionsList/types';

import { useAmelioTranslations } from '@/hooks';

/**
 * Props for YesNoQuestionAnswer.
 * Acts as the smart wrapper for survey answer flow.
 */
export interface YesNoQuestionAnswerProps {
    /** Selected answer values */
    selectedValues?: string[];

    /** Callback fired when answer changes */
    onChange: (values: string[]) => void;

    /** Optional custom class */
    className?: string;

    /** Optional test id */
    dataTestId?: string;
}

/**
 * YesNoQuestionAnswer
 *
 * - Binary Yes / No answer component
 * - Single selection only
 * - Uses AnswerOptionsList internally
 */
export const YesNoQuestionAnswer = ({
    selectedValues = [],
    onChange,
    className,
    dataTestId,
}: YesNoQuestionAnswerProps) => {
    const { t } = useAmelioTranslations();
    /**
     * Fixed Yes / No options.
     * These options are intentionally not configurable.
     */

    const YES_NO_OPTIONS: AnswerOptionConfig[] = [
        { label: t('common.yes'), value: 'yes' },
        { label: t('common.no'), value: 'no' },
    ];

    return (
        <AnswerOptionsList
            options={YES_NO_OPTIONS}
            selectedValues={selectedValues}
            onChange={onChange}
            multiple={false}
            maxSelection={1}
            className={className}
            dataTestId={dataTestId}
        />
    );
};

export default YesNoQuestionAnswer;
